export default "__VITE_ASSET__d6ad1f6c__"